module.exports = __webpack_public_path__ + "static/media/6_3.f6b86fd9.png";